import React, { useEffect, useState } from 'react';
import { Modal, Select, Button, DatePicker, Alert, Space, message, Switch, Row, Col, Typography } from 'antd';
import API from '../../../../services/API';
import { PLAID_ACCOUNT_STATE } from '../../../../constants/AppConstants';
import { formatDate } from '../../../../helpers/genericHelper';

const { Text } = Typography;
const PLAID_MSG = "User has no active Plaid connections to refund to.";
const REFUND_MSG = "User still has balance in their SB wallet. Please refund before filing bankruptcy.";

export default function FileBankruptcy({ userId, isBankruptStatus, onStatusChange, saveAndBuildCredit, furnishingEvents }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalLoading, showModalLoading] = useState(false);
  const [chapter, setChapter] = useState(false);
  const [reversed, setReversed] = useState(false);
  const [unblockUser, setUnblockUser] = useState(false);
  const [bankruptcyType, setBankruptcyType] = useState(null);
  const [filedDate, setFiledDate] = useState(null);
  const [errMsgs, setErrMsgs] = useState([]);
  const chapterOptions = ['CHAPTER_7', 'CHAPTER_11', 'CHAPTER_12', 'CHAPTER_13'];
  const bankruptcyTypeOptions = ['FILED', 'WITHDRAWN', 'DISCHARGED'];

  const [currentBankruptcyState, setCurrentBankruptcyState] = useState(null);

  useEffect(() => {
    const currentBankruptcyStatus = furnishingEvents?.length > 0
      ? furnishingEvents.reduce((latest, current) => 
          (current.createTs > latest.createTs) ? current : latest
        )
      : null;
    setCurrentBankruptcyState(currentBankruptcyStatus);
    console.log('furnishingEvents', furnishingEvents, 'currentBankruptcyState', currentBankruptcyState);
  }, [furnishingEvents?.length]);

  const postBankruptcy = () => {
    showModalLoading(true);

    const requestData = {
      userId,
      chapter,
      filedDate,
      reversed,
      unblockUser
    };
 
    const request = bankruptcyType === 'FILED' ? 
      API.postFileBankruptcy(requestData)
      : bankruptcyType === 'WITHDRAWN' ? API.postWithdrawBankruptcy(requestData)
      : bankruptcyType === 'DISCHARGED' ? API.postDischargeBankruptcy(requestData) : null;

    request?.then((resp) => {
      showModalLoading(false);
      setIsModalOpen(false);
      alert(resp?.message || 'Bankruptcy filed successfully!');
      if (onStatusChange) onStatusChange();
    }).catch((error) => {
      alert(error?.message || 'Something went wrong');
      showModalLoading(false);
    }) || message.error('Something went wrong');
  };

  const checkPlaidAccounts = async () => {
      try {
        const res = await API.getPlaidAccountDetails(userId);
        const validAccounts = res.plaidConnections
            .some((conn) => conn.isActive && conn.accountState === PLAID_ACCOUNT_STATE.LINKED);
       
        if (!validAccounts) setErrMsgs(prev => [...prev, PLAID_MSG]);
      } catch (error) {
        message.error("Unable to fetch Plaid Accounts");
        message.error(error?.response?.data?.error_message || error?.response?.data?.errorMessage);
      }
    };
    
  useEffect(() => {
    if (!isModalOpen) return;
    if (saveAndBuildCredit?.some(el => el.savingBuilderWalletTotal > 0)) {
      setErrMsgs([REFUND_MSG]);
      checkPlaidAccounts();
    }
  }, [saveAndBuildCredit, isModalOpen, userId])

  const handleCancel = () => {
    setIsModalOpen(false);
    setChapter(null);
    setFiledDate(null);
    setErrMsgs([]);
  };

  const buttonStyle = { marginRight: "2%" }

  return (
    <>
      <Button type="danger" style={buttonStyle} onClick={() => setIsModalOpen(true)}>
        {isBankruptStatus ? "Bankruptcy Filed!" : "File Bankruptcy for User"}
      </Button>
      <Modal
        title={"Confirmation"}
        centered
        mask={true}
        maskClosable={true}
        destroyOnClose={true}
        okButtonProps={{
          disabled: modalLoading || !chapter || !filedDate || errMsgs.length,
        }}
        width={"800px"}
        closable={true}
        open={isModalOpen}
        onOk={postBankruptcy}
        onCancel={handleCancel}
        className="confirm-modal"
      >
      <Space direction="vertical" size="large" style={{ display: 'flex' }}>
        <Row>
          <Col span={10}>
            <p>Please select the Bankruptcy Type?</p>
            <Select 
              onChange={(type) => setBankruptcyType(type)}
              placeholder={"Event Type..."}
              value={bankruptcyType}
              options={bankruptcyTypeOptions.map((option) => ({ label: option, value: option }))}
              style={{ width: 200 }}
            />
          </Col>
          <Col span={10} offset={1}>
            <p>Please provide the Bankruptcy Chapter?</p>
            <Select 
              onChange={(chapterValue) => setChapter(chapterValue)}
              placeholder={"Chapter..."}
              value={chapter}
              options={chapterOptions.map((option) => ({ label: option, value: option }))}
              style={{ width: 200 }}
            />
          </Col>
        </Row>
        <Row>
          <Col span={10}>
            <p>Please select if the bankruptcy is reversed?</p>
            <Switch onChange={(value) => setReversed(value)} checked={reversed} title='Reversed'/>
          </Col>
          <Col span={10} offset={1}>
            <p>Please Select the Bankruptcy Date?</p>
            <DatePicker value={filedDate} onChange={(dateValue) => setFiledDate(dateValue)} />
          </Col>
        </Row>

        {
          bankruptcyType === 'WITHDRAWN' && (
            <div>
              <p>Please select if the user should be unblocked?</p>
              <Switch onChange={(value) => setUnblockUser(value)} checked={unblockUser} />
            </div>
          )
        }

        {currentBankruptcyState && (
          <Alert message={<>
            <p>The current bankruptcy state is <Text strong type="danger" delete={currentBankruptcyState.reversed}>{currentBankruptcyState.name}</Text> created on {formatDate(currentBankruptcyState.createTs)}.</p>
          </>} />
        )}

        {errMsgs.length > 0 && (
          <Space direction="vertical" size="small" style={{ width: '100%' }}>
            {errMsgs.map((msg, index) => (
              <Alert key={index} message={msg} type="error" showIcon/>
            ))}
          </Space>
        )}
      </Space>
      </Modal>
    </>
  )
}